/* eslint-disable no-undef */
import { html, LitElement } from 'lit';

export class IconNotificationActive extends LitElement {
    render() {
        return html`
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <title>Bell</title>
                <g clip-path="url(#clip0_6480_60695)">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.51543 20.1843C7.92931 20.1676 8.27835 20.4896 8.29504 20.9035C8.31821 21.4779 8.7293 21.9932 9.28495 22.1421C9.8406 22.2909 10.4542 22.0503 10.7615 21.5644C10.9829 21.2143 11.4462 21.11 11.7963 21.3314C12.1464 21.5527 12.2507 22.016 12.0293 22.3661C11.372 23.4054 10.0882 23.9102 8.89672 23.591C7.70527 23.2717 6.84581 22.1926 6.79626 20.9639C6.77957 20.55 7.10156 20.201 7.51543 20.1843Z"
                        fill="currentColor"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M15.1057 0.40889C15.5058 0.516096 15.7433 0.927349 15.6361 1.32745L15.0537 3.50078C14.9465 3.90088 14.5353 4.13832 14.1352 4.03111C13.7351 3.92391 13.4976 3.51265 13.6048 3.11255L14.1872 0.93922C14.2944 0.53912 14.7056 0.301684 15.1057 0.40889Z"
                        fill="currentColor"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.1352 4.03111C10.5581 3.07265 6.79566 5.3425 5.83732 8.91908C4.98979 12.0821 4.06025 14.0768 3.32087 15.2978C3.15197 15.5767 2.993 15.8152 2.8472 16.018L17.8387 20.035C17.8202 19.8652 17.806 19.6782 17.7975 19.4725C17.7419 18.1155 17.939 15.9151 18.8773 12.4131C19.8431 8.80892 17.744 4.99809 14.1352 4.03111ZM19.5133 20.6867C19.5127 20.6856 19.5121 20.6843 19.5114 20.6828C19.5023 20.664 19.4793 20.6126 19.4514 20.5204C19.3954 20.3354 19.3199 19.9871 19.2963 19.4111C19.2489 18.2547 19.412 16.2134 20.3262 12.8014C21.497 8.43188 18.9669 3.77285 14.5234 2.58222C10.1124 1.4003 5.55202 4.18827 4.38843 8.53085C3.57058 11.5831 2.6911 13.442 2.0378 14.5208C1.7113 15.0599 1.44132 15.4042 1.26357 15.6057C1.17466 15.7065 1.10864 15.7717 1.06993 15.8079C1.05056 15.826 1.03798 15.8368 1.03275 15.8413C1.03203 15.8419 1.03145 15.8424 1.03101 15.8427C0.809662 16.0169 0.704318 16.3008 0.759095 16.5777C0.814569 16.8581 1.02461 17.0826 1.30072 17.1566L18.6874 21.8153C18.9938 21.8974 19.3188 21.7778 19.4989 21.5167C19.671 21.2671 19.6753 20.9398 19.5133 20.6867Z"
                        fill="currentColor"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_6480_60695">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        `;
    }
}

if (!customElements.get('icon-notification-active24')) {
    customElements.define('icon-notification-active24', IconNotificationActive);
}
